import { render, staticRenderFns } from "./TuPortalProfileUpdate.vue?vue&type=template&id=0001725a"
import script from "./TuPortalProfileUpdate.vue?vue&type=script&lang=js"
export * from "./TuPortalProfileUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports